export const BUGMEN_TABS = [
  {
    name: "China Bull",
    tab: [
      {
        name: "Marty",
        strings: [
          {
            name: "E",
            tab: [
              "0",
              "-",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "2",
              "-",
              "|",
              "r",
              "-",
              "-",
              "-",
              "-",
              "5",
              "-",
              "3",
              "-",
              "|",
              "o",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "5",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "1",
              "-",
              "3",
              "-",
              "3",
              "-",
              "3",
              "-",
              "3",
              "-",
              "|",
              "e",
              "-",
              "-",
              "-",
              "-",
              "3",
              "-",
              "1",
              "-",
              "|",
              "u",
              "3",
              "-",
              "-",
              "-",
              "1",
              "-",
              "3",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "0",
              "-",
              "0",
              "-",
              "2",
              "-",
              "0",
              "-",
              "2",
              "-",
              "|",
              "f",
              "-",
              "-",
              "-",
              "-",
              "4",
              "-",
              "2",
              "-",
              "|",
              "t",
              "0",
              "-",
              "-",
              "-",
              "2",
              "-",
              "4",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "2",
              "-",
              "5",
              "-",
              "2",
              "-",
              "2",
              "-",
              "-",
              "-",
              "|",
              "r",
              "10",
              "-",
              "5",
              "-",
              "4",
              "-",
              "2",
              "-",
              "|",
              "r",
              "5",
              "-",
              "2",
              "-",
              "2",
              "-",
              "5",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "3",
              "-",
              "5",
              "-",
              "-",
              "-",
              "3",
              "-",
              "-",
              "-",
              "|",
              "e",
              "10",
              "-",
              "5",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "o",
              "5",
              "-",
              "2",
              "-",
              "-",
              "-",
              "0",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "n",
              "8",
              "-",
              "3",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Dustbin For Ambition",
    tab: [
      {
        name: "Marty",
        strings: [
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "3",
              "-",
              "3",
              "-",
              "-",
              "-",
              "3",
              "-",
              "3",
              "-",
              "3",
              "-",
              "3",
              "-",
              "1",
              "|",
              "-",
              "3",
              "-",
              "3",
              "-",
              "3",
              "-",
              "1",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "0",
              "-",
              "0",
              "-",
              "5",
              "-",
              "4",
              "-",
              "0",
              "-",
              "0",
              "-",
              "5",
              "-",
              "2",
              "|",
              "-",
              "2",
              "-",
              "5",
              "-",
              "4",
              "-",
              "0",
              "-",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "2",
              "-",
              "-",
              "-",
              "5",
              "-",
              "0",
              "-",
              "2",
              "-",
              "-",
              "-",
              "5",
              "-",
              "-",
              "|",
              "-",
              "2",
              "-",
              "5",
              "-",
              "0",
              "-",
              "2",
              "-",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "-",
              "-",
              "2",
              "-",
              "3",
              "-",
              "-",
              "-",
              "-",
              "-",
              "2",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "3",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Mannequin",
    tab: [
      {
        name: "Marty",
        strings: [
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "r",
              "e",
              "f",
              "r",
              "e",
              "n",
              "|",
              "p",
              "r",
              "e",
              "d",
              "-",
              "s",
              "o",
              "l",
              "e",
              "m",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "4",
              "-",
              "-",
              "|",
              "11",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "11",
              "-",
              "10",
              "-",
              "8",
              "-",
              "6",
              "-",
              "|",
              "4",
              "-",
              "4",
              "|",
              "-",
              "10",
              "|",
              "4",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "11",
              "-",
              "11",
              "-",
              "9",
              "-",
              "8",
              "-",
              "|",
              "4",
              "-",
              "6",
              "|",
              "13",
              "11",
              "|",
              "6",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "9",
              "-",
              "9",
              "-",
              "9",
              "-",
              "8",
              "-",
              "|",
              "-",
              "-",
              "6",
              "|",
              "-",
              "-",
              "|",
              "6",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Misanthropic Love Song",
    tab: [
      {
        name: "Marty",
        strings: [
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "6",
              "-",
              "6",
              "-",
              "8",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "7",
              "6",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "7",
              "-",
              "7",
              "-",
              "9",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "8",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "8",
              "-",
              "7",
              "-",
              "10",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "8",
              "-",
              "-",
              "13",
              "-",
              "-",
              "|",
              "-",
              "8",
              "-",
              "-",
              "-",
              "10",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "11",
              "0",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Planet Y",
    tab: [
      {
        name: "Marty",
        strings: [
          {
            name: "E",
            tab: [
              "i",
              "n",
              "t",
              "r",
              "o",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "b",
              "r",
              "i",
              "d",
              "g",
              "e",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "12",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "12",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "10",
              "9",
              "4",
              "0",
              "-",
              "|",
              "13",
              "13",
              "10",
              "10",
              "-",
              "|",
              "13",
              "14",
              "16",
              "/",
              "14",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "0",
              "0",
              "0",
              "0",
              "-",
              "|",
              "0",
              "-",
              "0",
              "0",
              "-",
              "|",
              "0",
              "0",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
      {
        name: "Daja vyhravka",
        strings: [
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "-",
              "-",
              "-",
              "5",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "3",
              "4",
              "6",
              "-",
              "6",
              "4",
              "3",
              "-",
              "3",
              "-",
              "3",
              "4",
              "6",
              "6",
              "4",
              "3",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "5",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Reverie",
    tab: [
      {
        name: "Daja I",
        strings: [
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "7",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "7",
              "-",
              "-",
              "7",
              "5",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "7",
              "-",
              "14",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "5",
              "7",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "6",
              "9",
              "-",
              "7",
              "7",
              "-",
              "7",
              "-",
              "-",
              "-",
              "-",
              "-",
              "7",
              "-",
              "14",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "11",
              "-",
              "6",
              "7",
              "6",
              "-",
              "-",
              "6",
              "7",
              "6",
              "4",
            ],
          },
          {
            name: "D",
            tab: [
              "x",
              "-",
              "-",
              "0",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "7",
              "9",
              "-",
              "-",
              "14",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "12",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "7",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "9",
              "7",
              "9",
              "-",
              "-",
              "-",
              "-",
              "0",
              "0",
              "2",
              "4",
              "5",
              "-",
              "|",
              "10",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
      {
        name: "Daja II",
        strings: [
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "7",
              "-",
              "10",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "5",
              "-",
              "5",
              "-",
              "7",
              "-",
              "10",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "6",
              "-",
              "6",
              "-",
              "7",
              "-",
              "11",
              "-",
              "|",
              "-",
              "6",
              "-",
              "7",
              "9",
              "11",
              "9",
              "7",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "7",
              "-",
              "6",
              "-",
              "9",
              "-",
              "12",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "0",
              "-",
              "-",
              "-",
              "9",
              "-",
              "12",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "7",
              "-",
              "10",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Xanadu",
    tab: [
      {
        name: "Marty",
        strings: [
          {
            name: "E",
            tab: [
              "r",
              "e",
              "f",
              "r",
              "e",
              "n",
              "!",
              "-",
              "-",
              "-",
              "|",
              "s",
              "-",
              "-",
              "-",
              "2",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
          {
            name: "B",
            tab: [
              "-",
              "-",
              "3",
              "-",
              "-",
              "-",
              "1",
              "-",
              "0",
              "0",
              "|",
              "l",
              "-",
              "1",
              "-",
              "3",
              "-",
              "8",
              "-",
              "8",
              "-",
              "1",
              "-",
              "1",
              "|",
              "-",
              "-",
              "1",
              "-",
              "1",
              "-",
              "-",
            ],
          },
          {
            name: "G",
            tab: [
              "2",
              "-",
              "2",
              "-",
              "-",
              "-",
              "2",
              "-",
              "2",
              "0",
              "|",
              "o",
              "-",
              "2",
              "-",
              "2",
              "-",
              "9",
              "-",
              "9",
              "-",
              "2",
              "-",
              "2",
              "|",
              "4",
              "-",
              "2",
              "-",
              "0",
              "-",
              "-",
            ],
          },
          {
            name: "D",
            tab: [
              "3",
              "-",
              "3",
              "-",
              "2",
              "-",
              "2",
              "-",
              "2",
              "2",
              "|",
              "k",
              "-",
              "3",
              "-",
              "-",
              "-",
              "9",
              "-",
              "10",
              "-",
              "3",
              "-",
              "2",
              "|",
              "5",
              "-",
              "2",
              "-",
              "2",
              "-",
              "-",
            ],
          },
          {
            name: "A",
            tab: [
              "3",
              "-",
              "-",
              "-",
              "2",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "a",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "10",
              "-",
              "3",
              "-",
              "-",
              "|",
              "-",
              "-",
              "0",
              "-",
              "2",
              "-",
              "-",
            ],
          },
          {
            name: "E",
            tab: [
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
              "|",
              "3",
              "-",
              "-",
              "-",
              "-",
              "-",
              "-",
            ],
          },
        ],
      },
    ],
  },
];
